import React from "react";
import "../../../../App.css";
import "./Home.css";
import { USBanner } from "../../../Banner/Banner";
import ReactTooltip from "react-tooltip";
import { cdn } from "../../../../consts/cdn";

//Images
const BannerDesktop = cdn.images + "Home/Banner-Desktop.jpg";
const BannerMobile = cdn.images + "Home/Banner-Mobile.jpg";

function Home() {
  return (
    <div className="home">
      <USBanner
        imgdesktop={BannerDesktop}
        imgmobile={BannerMobile}
        bold1="NO VISIBLE SCARS, LESS PAIN"
        text1="AND A QUICK RETURN "
        text2="TO YOUR BUSY LIFE"
        buttons={[
          {
            text: "Healthcare Professionals",
            route: "/healthcareprofessionals",
          },
          {
            text: "Patients",
            route: "/patients",
          },
        ]}
        color="#365B7E"
      />
      <ReactTooltip />
    </div>
  );
}

export default Home;
